import Backbone from 'backbone'
import template from './simple-dataset-field-selector.hbs'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import DatasetsFilterBadges from 'scoreboard/datasets/filters/datasets-filter-badges'
import $ from 'jquery'
import Dataset from 'scoreboard/datasets/model/dataset'
import * as aggregationTypeOptions from 'scoreboard/datasets/aggregation-type-options'
import dropdown from 'scoreboard/components/dropdown'
import DashboardData from 'scoreboard/dashboards/dashboard-data'
const ALL_TIME = Dataset.ALL_TIME
const TOTAL = Dataset.TOTAL
import httpStatusCodes from 'http-status-codes'
import renderFieldDropdown from 'scoreboard/datasets/render-field-dropdown'
import noPermissionTemplate from 'scoreboard/components/no-permission.hbs'
import errorHandler from 'scoreboard/components/error-handler'
import LoadingDots from 'scoreboard/components/loading-dots'
import formHelper from 'scoreboard/components/form-helper'
import PlaceholderSelect from 'scoreboard/components/placeholder-select'
import ObjectSelectorButton from 'scoreboard/components/object-selector-button'
import * as datasetSelectorOptions from 'scoreboard/datasets/dataset-selector-options'
import DataType from 'scoreboard/datasets/model/data-type'
const { DATE } = DataType

const SimpleDatasetFieldSelector = Backbone.View.extend({

	className: 'simple-dataset-field-selector',

	events: {
		'click .add': 'addFilter',
		'click .choose-dataset': 'onClickChooseDataset'
	},

	/**
	 * The MarkedField for the dropdown which specifies the field within the
	 * dataset used to aggregate dataset values.
	 *
	 * @type {MarkedField}
	 */
	_aggregationField: null,

	/**
	 * The MarkedField for the dropdown which specifies the date field within
	 * the dataset used to aggregate dataset values.
	 *
	 * @type {MarkedField}
	 */
	_dateField: null,

	/**
	 * A dataset field selector that works entirely with dropdowns instead of trees.
	 * Used in places like chart series selection.
	 *
	 * @constructs
	 *
	 * @param {Object} opt
	 * @param {Object} opt.data
	 * @param {Dataset[]} opt.data.datasets
	 * @param {Object} opt.initial
	 * @param {Number} opt.initial.domainObjectId
	 * @param {Number} opt.initial.datasetAggregationFieldId
	 * @param {Object[]} opt.initial.datasetFilters
	 * @param {Object} [opt.showAggregationType=true] indicates whether the main
	 * 					field dropdown should be shown
	 * @param {Object} [opt.showDateField=true] indicates whether the date field
	 * 					dropdown should be shown
	 * @param {Object} [opt.allowTotal=true] indicates whether "Number of X" should
	 * 					be available in the main field dropdown
	 * @param {Booean} [opt.allowLinkedFields=true] indicates whether visible linked
	 * 					fields should be available in the field dropdowns
	 * @param {Object} [opt.allowAggPercentage=true] indicates whether "% Percentage"
	 * 					Aggregation should be available in the aggregation type
	 * 					dropdown
	 * @param {Object|Function} [opt.renderFieldDropdownOptions] extra options to
	 * 					be passed along to renderFieldDropdown(). Can be an Object
	 * 					or a function that returns an object
	 * @param {Boolean} [opt.allowAppCalendar=true] indicates whether the app calendar
	 *					should be available for date filters
	 */
	initialize: function(opt) {
		this.options = opt || {}
		this.data = opt.data

		_.defaults(this.options, {
			showAggregationType: true,
			showDateField: true,
			allowTotal: true,
			allowLinkedFields: true,
			allowAggPercentage: true,
			allowAppCalendar: true
		})
	},

	render: function() {
		this.$el.append(template())
		this.loadingDots = new LoadingDots({ el: this.$('.loading-dots-container') }).render()

		this.placeholderSelect = new PlaceholderSelect()
		this.$('.placeholder-select').replaceWith(this.placeholderSelect.el)
		this.placeholderSelect.render()

		this._renderDatasetSelect(this.options.initial)

		return this
	},

	_fetchDatasetInfo: function({ success, error }) {
		this.xhr && this.xhr.cancel()

		// get the IDs of any tree items referenced in existing filters
		let treeItemIds = _(this.options.initial.datasetFilters)
			.flatMap(f => _.keys(f.rollupIsAnyFilters))
			.uniq()
			.join()

		this.xhr = $.ajax({
			url: 'api/datasets/chart-series-selection-info?treeItemIds=' + treeItemIds,
			success: success,
			error: error
		})
	},

	_renderDatasetSelect: function(opt) {
		this._renderNonDatasetIdFields()

		this._fetchDatasetInfo({
			success: info => {
				this.loadingDots.clear()
				delete this.loadingDots
				this.$('label.dataset').removeClass('is-not-displayed')

				let dataset
				if (opt.domainObjectId) {
					dataset = new Dataset(DashboardData.datasets(this.data, opt.domainObjectId))
					this.selectedDatasetId = dataset.id

					this._renderNonDatasetIdFields({
						dataset,
						aggregationFieldId: opt.datasetAggregationFieldId,
						aggregationVisibleLinkedFieldId: opt.datasetAggregationVisibleLinkedFieldId,
						aggregationType: opt.datasetAggregationType,
						dateFieldId: opt.datasetDateFieldId,
						dateVisibleLinkedFieldId: opt.datasetDateVisibleLinkedFieldId,
						filters: opt.datasetFilters,
						// Note that the initial rendering is the only time we really need to pass in the treeItems,
						// because we may already have filters that reference tree items.
						// When a filter is added or edited, FilterBadges takes care of retrieving any necessary tree items.
						// When a new dataset is picked, there won't be any filters, so we don't need any tree items.
						treeItems: info.treeItems
					})
				}

				let selectorOptions = _.extend(
					datasetSelectorOptions.forButton({ dataset }),
					{ message: i18n.get('report.designer.chooseDataset') })

				this.datasetSelector = new ObjectSelectorButton(selectorOptions)

				this.datasetSelector.on('change', selected => {
					this.selectedDatasetId = selected.id
					this._onDatasetChange()
				})

				this.$('.dataset').append(this.datasetSelector.el)
				this.datasetSelector.render()

				this.trigger('load')
			},
			error: xhr => errorHandler(xhr, { handler: () => {
				if (xhr.status === httpStatusCodes.NOT_FOUND) {
					this.$el.html(noPermissionTemplate({
						message: i18n.get('common.security.missing.datasets')
					}))
					this.trigger('noPermission')
					return true
				}
			}})
		})
	},

	_onDatasetChange: function() {
		let datasetId = this.selectedDatasetId

		if (datasetId) {
			this._renderNonDatasetIdFields({
				datasetLoading: true
			})

			this._fetchDataset(datasetId, (data) => {
				// need this for permission checks; if data returned from the XHR, then
				// user must be able to view it (or error would be thrown)
				data.view = true

				DashboardData.datasets(this.data, datasetId, data)

				var dataset = new Dataset(data)

				this._renderNonDatasetIdFields({
					dataset,
					datasetLoading: false,
					filters: []
				})

				this.trigger('change')
			})
		} else {
			this._renderNonDatasetIdFields()
			this.trigger('change')
		}
	},

	_fetchDataset: function(datasetId, success) {
		$.get(`api/datasets/${datasetId}?fields=true&linkedDatasets=true`, success)
	},

	selectedDataset: function() {
		let id = this.selectedDatasetId
		return _.isNil(id) ? null : new Dataset(DashboardData.datasets(this.data, id))
	},

	selectedAggregationFieldIdentifier: function() {
		return this._aggregationField ? toInt(this._aggregationField.val()) : null
	},

	/**
	 *
	 * @param datasetLoading
	 * @param {Dataset} dataset
	 * @param {Number} aggregationFieldId
	 * @param {Number} aggregationVisibleLinkedFieldId
	 * @param {String} aggregationType
	 * @param {Number} dateFieldId
	 * @param {Number} dateVisibleLinkedFieldId
	 * @param {Object[]} filters
	 * @param treeItems
	 * @private
	 */
	_renderNonDatasetIdFields: function({ datasetLoading, dataset,
			aggregationFieldId, aggregationVisibleLinkedFieldId,
			aggregationType, dateFieldId, dateVisibleLinkedFieldId, filters,
			treeItems } = {}) {
		if (dataset && _.isNil(aggregationFieldId)) {
			aggregationFieldId = Dataset.TOTAL
		}

		let aggregationFieldIdentifier = dataset && dataset.idsToFieldIdentifier({
			fieldId: aggregationFieldId,
			visibleLinkedFieldId: aggregationVisibleLinkedFieldId
		})
		this._renderAggregationField({
			dataset,
			selectedId: aggregationFieldIdentifier,
			loading: datasetLoading
		})

		this._renderAggregationType({
			dataset,
			fieldIdentifier: aggregationFieldIdentifier,
			aggregationType
		})

		this._renderDateField({ dataset })

		this._renderFilterBadges(dataset, filters, treeItems)
	},

	_renderAggregationField: function({ dataset, selectedId, loading } = {}) {
		this._aggregationField && this._aggregationField.remove()

		let show = !!dataset
		this.$('label.aggregation-field').toggleClass('is-not-displayed', !show && !loading)

		this.placeholderSelect.toggle(loading)

		if (show) {
			let aggregationFieldSelect = $('<select name="aggregationFieldIdentifier"></select>').appendTo(this.$('.aggregation-field'))
			let dropdownOptions = {
				el: aggregationFieldSelect,
				dataset,
				selectedId: selectedId || TOTAL,
				includeTotal: this.options.allowTotal,
				includeNativeTotal: this.options.allowTotal,
				required: true
			}

			let extraOptions = this.options.renderFieldDropdownOptions
			if (_.isObjectLike(extraOptions)) {
				_.extend(dropdownOptions, extraOptions)
			} else if (_.isFunction(extraOptions)) {
				_.extend(dropdownOptions, extraOptions({ dataset }))
			}

			if (!this.options.allowLinkedFields) {
				// Easiest way to filter out linked fields is just to give renderFieldDropdown()
				// an empty array of allowed ids
				dropdownOptions.allowedVisibleLinkedFieldIds = []
			}

			this._aggregationField = renderFieldDropdown(dropdownOptions)

			aggregationFieldSelect.change(() => {
				// when the field changes, we need to update the aggregation type options
				this._renderAggregationType({
					dataset: this.selectedDataset(),
					fieldIdentifier: this.selectedAggregationFieldIdentifier(),
					aggregationType: aggregationFieldSelect.val()
				})
				this.trigger('change')
			})
		}
	},

	/**
	 * @param {Dataset} dataset
	 */
	_renderDateField: function({ dataset } = {}) {
		this._dateField && this._dateField.remove()

		let show = dataset && this.options.showDateField

		this.$('.date-field').toggleClass('is-not-displayed', !show)

		if (show) {
			let dateFieldSelect = $('<select name="dateFieldIdentifier"></select>').appendTo(this.$('.date-field'))
			let dateFieldIdentifier = dataset.idsToFieldIdentifier({
				fieldId: this.options.initial.datasetDateFieldId || ALL_TIME,
				visibleLinkedFieldId: this.options.initial.datasetDateVisibleLinkedFieldId
			})
			// #36639 default to "All Time" if changing to a different dataset
			// from the original
			if (this.selectedDatasetId != this.options.initial.domainObjectId) {
				dateFieldIdentifier = ALL_TIME
			}
			let allowedVisibleLinkedFields = _.filter(dataset.get('visibleLinkedFields'), vlf => {
				let field = dataset.getFieldByIds({
					fieldId: vlf.fieldId,
					visibleLinkedFieldId: vlf.id
				})
				return field.dataType === DATE
			})
			this._dateField = renderFieldDropdown({
				el: dateFieldSelect,
				dataset,
				allowedFieldIds: _.map(dataset.combinedFields.filter(f => f.dataType === DATE), 'id'),
				allowedVisibleLinkedFieldIds: _.map(allowedVisibleLinkedFields, 'id'),
				selectedId: dateFieldIdentifier,
				includeAllTime: true,
				required: this.options.showDateField
			})

			dateFieldSelect.change(() => {
				this.trigger('change')
			})
		}
	},

	_renderAggregationType: function({ dataset, fieldIdentifier, aggregationType } = {}) {
		let show = dataset && !_.isNil(fieldIdentifier) && this.options.showAggregationType

		this.$('.aggregation-type').toggleClass('is-not-displayed', !show)
		let select = this.$('.aggregation-type select').empty()

		if (show) {
			let aggTypeOptions = aggregationTypeOptions.forField(dataset, fieldIdentifier)

			// if the provided type isn't in the new options list (changed fields to one that doesn't
			// have the old aggregation type), just default to the first one
			if (!aggTypeOptions.find(type => type.id === aggregationType)) {
				aggregationType = aggTypeOptions[0] ? aggTypeOptions[0].value : null
			}

			// see #27137, #25920
			if (!this.options.allowAggPercentage) {
				_.remove(aggTypeOptions, option => option.id === 'percentage')
			}

			dropdown.idLabels(select, aggTypeOptions, aggregationType)
		}
	},

	_renderFilterBadges: function (dataset, filters, treeItems) {
		this.filterBadges && this.filterBadges.remove()
		delete this.filterBadges

		this.$('.panel.filters').toggleClass('is-not-displayed', !(dataset && dataset.get('view')))

		if (dataset && dataset.get('view')) {
			let treeItemsById = _.keyBy(treeItems, 'id')

			this.filterBadges = new DatasetsFilterBadges({
				model: dataset,
				filters: filters,
				noneMessage: i18n.get('common.thereAreNo', 'datasets.records.activeFilters'),
				showPermissionFilters: false,
				allowAppCalendar: this.options.allowAppCalendar,
				treeItemsById
			}).render()

			this.listenTo(this.filterBadges, 'add-filter delete-filter edit-filter', () => this.trigger('change'))

			this.$('.filters .panel-content').html(this.filterBadges.el)
		}
	},

	addFilter: function() {
		this.filterBadges.addFilter()
	},

	/**
	 * Returns the data that was selected in this selector.
	 */
	selected: function() {
		let data = formHelper.readFromDom(this.el)

		let datasetId = this.selectedDatasetId
		let domainObject = DashboardData.datasets(this.data, datasetId)

		if (!domainObject) {
			return null
		}

		let dataset = new Dataset(domainObject)
		let datasetAggregationIds = dataset.fieldIdentifierToIds(
			this.selectedAggregationFieldIdentifier())
		let datasetDateIds = dataset.fieldIdentifierToIds(
			data.dateFieldIdentifier)
		let selected = {
			domainObjectId: datasetId,
			domainObject,
			datasetAggregationFieldId: _.get(datasetAggregationIds, 'fieldId'),
			datasetAggregationVisibleLinkedFieldId: _.get(datasetAggregationIds, 'visibleLinkedFieldId'),
			datasetAggregationType: data.aggregationType,
			datasetDateFieldId: _.get(datasetDateIds, 'fieldId'),
			datasetDateVisibleLinkedFieldId: _.get(datasetDateIds, 'visibleLinkedFieldId'),
			datasetFilters: this.filterBadges && this.filterBadges.filters
		}

		let requiredFields = [ selected.domainObjectId,
			selected.datasetAggregationFieldId ]
		if (this.options.showAggregationType) {
			requiredFields.push(selected.datasetAggregationType)
		}
		if (this.options.showDateField) {
			requiredFields.push(selected.datasetDateFieldId)
		}

		// Note that the TOTAL pseudo-field is 0, so we can't do a simple falsey check
		if (_.every(requiredFields, v => !_.isNil(v))) {
			return selected
		}
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.filterBadges, this.loadingDots, this.datasetSelector], 'remove')
		this.removeMarkedFields()
	},

	removeMarkedFields: function() {
		_.invokeMap([ this._dateField, this._aggregationField ], 'remove')
	}
})

function toInt(val) {
	return _.isEmpty(val) ? null : parseInt(val)
}

export default SimpleDatasetFieldSelector

SimpleDatasetFieldSelector.__filename__ = 'datasets/simple-dataset-field-selector.js'
